import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Shield } from "lucide-react";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // Extract token from URL hash (for Chrome extension sync)
    const hash = window.location.hash;
    if (hash && hash.length > 1) {
      const token = hash.substring(1); // Remove the #
      // Store in localStorage so extension's token-sync.js can pick it up
      localStorage.setItem("cartcontrol_token", token);
    }

    // Cookie is already set by the backend redirect.
    // Refresh auth state, then navigate to dashboard.
    refreshUser().then(() => {
      navigate("/dashboard", { replace: true });
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center" data-testid="auth-callback-page">
      <div className="text-center">
        <Shield className="w-8 h-8 text-gray-900 mx-auto mb-4 animate-pulse" />
        <p className="text-sm text-gray-500">Signing you in...</p>
      </div>
    </div>
  );
}
